import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M10 13.333A.833.833 0 1010 15a.833.833 0 000-1.667zm8.892 1.225L12.183 2.892a2.5 2.5 0 00-4.366 0L1.15 14.558a2.5 2.5 0 002.133 3.775h13.434a2.5 2.5 0 002.175-3.775zm-1.442 1.667a.834.834 0 01-.733.425H3.283a.834.834 0 01-.733-.425.833.833 0 010-.833L9.217 3.725a.833.833 0 011.483 0l6.708 11.667a.833.833 0 01.042.85v-.017zM10 6.667a.833.833 0 00-.833.833v3.333a.833.833 0 001.666 0V7.5A.833.833 0 0010 6.667z"
        fill="#FF2E00"
      />
    </Svg>
  );
}

export default SvgComponent;
